import React from 'react';
import styled from '@emotion/styled';
import Responsive from '../../../../../ui/utils/Responsive';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';
import { PARKING_ADD_GUEST_BOOKING_HASH_PATTERN } from '../guest-booking/AddGuestBookingDialogRoute';

const AddGuestBookingLink = styled.a`
	display: none;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		display: block;
		margin-top: 24px;
	}
`;

export const MyBookingsFooter = () => {
	const { t } = useTranslation();

	return (
		<>
			<AddGuestBookingLink href={PARKING_ADD_GUEST_BOOKING_HASH_PATTERN}>
				{t('parking_landing_your_bookings_retrieve_button')}
			</AddGuestBookingLink>
		</>
	);
};
